/* eslint-disable react-hooks/exhaustive-deps */
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import ICONS from "../../../assets/Icons";
import SvgComponent from "../../_utils/SVGComponent";
import "./index.css";

const PaginationComponent = ({
  selectedValue,
  handleSelect,
  data,
  dropdownOptions,
  handlePagination,
  currentPage,
  typepop,
  flowType,
  handleRejectAllTransaction,
  accountType,
  totalCount,
  accountFlow,
  type,
  payload,
  setIsOpen,
  typePopup,
}) => {

  const dropdownRef = useRef(null);
  const paginationRef = useRef(null);
  const paginationCompRef = useRef(null);
  const indicatorRef = useRef(null);

  const services = useSelector((state) => state.refreshToken.services);
  const [isPerPageOpen, setIsPerPageOpen] = useState(false);
  const isSelectedSize = (value) => String(selectedValue) === String(value);

  const handleChange = (e, page) => {
    handlePagination(page);
  };

  useEffect(() => {
    const handleDropDown = (e) => {
      if (dropdownRef.current && dropdownRef.current.contains(e.target)) {
      } else {
        setIsPerPageOpen(false);
      }
    };
    document.addEventListener("click", handleDropDown);
  }, [dropdownRef]);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);

  useEffect(() => {
    const selectedButton = paginationRef.current?.querySelector(
      "button.Mui-selected",
    );

    if (selectedButton && indicatorRef.current && paginationRef.current) {
      const buttonRect = selectedButton.getBoundingClientRect();
      const containerRect = paginationRef.current.getBoundingClientRect();

      const offsetLeft = buttonRect.left - containerRect.left;
      const offsetWidth = buttonRect.width;

      indicatorRef.current.style.left = `${offsetLeft}px`;
      indicatorRef.current.style.width = `${offsetWidth}px`;
    }
  }, [currentPage, isMobile, data]);

  useEffect(() => {
    const handleDropDown = (e) => {
      if (
        paginationCompRef.current &&
        !paginationCompRef.current.contains(e.target)
      ) {
        setIsPerPageOpen(false);
      }
    };

    document.addEventListener("mousedown", handleDropDown, true);
    return () => {
      document.removeEventListener("mousedown", handleDropDown, true);
    };
  }, []);
  return (
    <>
      <div
        className={`flex flex-col bg-primary-nav shadow-box-shadow-top w-full  ${typePopup || typepop === "RejectAllTransactionPopup" ? "rounded-b-border-radius-md" : "rounded-none "} ${typePopup || typepop === "RejectAllTransactionPopup" || type === "scheduleInternalAcc" ? "" : "h-pagination-height"}`}
        ref={paginationCompRef}
      >
        <div
          className="w-auto max-w-tab-width-normal mx-auto flex justify-between"
          style={{
            width: "var(--width-full)",
            padding: isMobile
              ? "var(--padding-base) var(--padding-button-l)"
              : "var(--padding-base) var(--padding-sm)",
            alignItems: isMobile ? "center" : "",
          }}
        >
          <div className="flex">
            <p className="my-auto mr-margin-sm ml-margin-base text-font-xs text-text-secondary">
              Per page :
            </p>
            <div
              ref={dropdownRef}
              className={`block h-tertiary-btn-height relative rounded-border-radius-sm m-auto mb-margin-sm ml-margin-base w-banklogo-width-lg
              ${type === "multi_Entity" ? "cursor-default" : "cursor-pointer"}`}
            >
              <div
                className="pagination-perpage-dropdown"
                onClick={() => {
                  setIsOpen?.(false);
                  if (type === "multi_Entity") return;
                  setIsPerPageOpen(!isPerPageOpen);
                }}
                style={{
                  position: isPerPageOpen ? "absolute" : "relative",
                  bottom: "var(--bottom-base)",
                  borderRadius: "var(--border-radius-sm)",
                  ...(isPerPageOpen
                    ? {
                        height: "-webkit-fill-available",
                        paddingTop: "var(--pagination-padding-top)",
                      }
                    : {
                        padding: "var(--padding-md)",
                        paddingTop: "var(--padding-button-s)",
                      }),
                }}
              >
                <div className="absolute top-top-base w-width-full p-[var(--pagination-padding)] bg-primary-nav-act flex flex-col gap-gap-xs">
                  {dropdownOptions?.map((value) => (
                    <div
                      key={value}
                      className={`flex h-icon-md rounded-border-radius-sm justify-start items-center text-left text-font-xs text-text-primary p-padding-sm font-semibold relative z-z-index-base global-hover-white ${isSelectedSize(value) ? "bg-primary-card" : ""}`}
                      onClick={() => handleSelect(value)}
                    >
                      {value}
                      <div
                        style={{
                          width: "var(--width-full)",
                          display: isSelectedSize(value) ? "flex" : "none",
                          textAlign: "right",
                          justifyContent: "end",
                        }}
                      >
                        <SvgComponent
                          url={ICONS?.CHECK_MARK_WHITE}
                          height="var(--icon-xs)"
                          width="var(--icon-xs)"
                          color="var(--text-primary)"
                        />
                      </div>
                    </div>
                  ))}
                </div>
                <div
                  style={{
                    height: "min-content",
                    backgroundColor: "var(--primary-nav-act)",
                    bottom: "var(--bottom-base)",
                    top: "auto",
                  }}
                  className={`flex justify-between w-width-full items-center flex-wrap absolute z-z-index-base ${type === "multi_Entity" ? "" : "global-hover-white"} top-top-base px-[var(--pagination-padding)]`}
                >
                  <div className="border-t border-primary-bg flex items-center gap-gap-xs py-[var(--pagination-padding)] justify-between w-width-full">
                    <span className="text-text-primary text-font-xs pl-padding-sm font-semibold w-fit text-left transition-all duration-200 font-sans">
                      {selectedValue}
                    </span>
                    <div
                      className={`mr-margin-sm flex-shrink-0 ${type === "multi_Entity" ? "hidden" : "block"}`}
                    >
                      <SvgComponent
                        url={
                          isPerPageOpen
                            ? ICONS?.ARROW_DOWN_WHITE
                            : ICONS?.ARROW_UP_WHITE
                        }
                        color={"var(--text-primary)"}
                        height={"var(--icon-xs)"}
                        width={"var(--icon-xs)"}
                        alt="StatusIcon"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="my-auto justify-center items-center flex relative"
            ref={paginationRef}
          >
            {data?.total_count > 0 && (
              <div
                className="absolute py-padding-sm px-padding-sm rounded-border-radius-md bg-primary-nav-act hover:scale-[1.02] z-z-index-base"
                style={{
                  transition:
                    "transform 0.3s ease-in-out, left 0.3s ease-in-out, width 0.3s ease-in-out",
                }}
                ref={indicatorRef}
              ></div>
            )}

            <Pagination
              sx={{
                zIndex: 1,
                "& .MuiPaginationItem-ellipsis": {
                  color: "var(--text-primary) !important",
                },
                "& .MuiPaginationItem-root": {
                  borderRadius: "var(--border-radius-md) !important",
                },
                "& .MuiPagination-ul": {
                  display: "flex",
                  justifyContent: "center",
                  fontFamily: "Open Sans",
                },
              }}
              size="small"
              count={data?.title?.total_pages || 1}
              shape="rounded"
              page={Number(currentPage) || 1}
              onChange={handleChange}
              siblingCount={isMobile ? 0 : 1}
              boundaryCount={isMobile ? 0 : 1}
              classes={{ ul: "custom-pagination-ul" }}
              renderItem={(item) => {
                if (isMobile) {
                  if (
                    item.type === "start-ellipsis" ||
                    item.type === "end-ellipsis"
                  ) {
                    return null;
                  }
                  if (
                    item.type === "page" &&
                    item.page !== Number(currentPage)
                  ) {
                    return null;
                  }
                }

                return (
                  <PaginationItem
                    {...item}
                    sx={{
                      fontWeight: "var(--semibold)",
                      fontSize: "var(--font-xs)",
                      fontFamily: "Open Sans",
                      color: "var(--text-primary)",
                      margin: "var(--margin-base) var(--margin-xs)",
                      minWidth: "var(--page-no-capsule-width) !important",

                      "&:not(.Mui-selected):hover": {
                        backgroundColor: "var(--brand-primary-raised-default)",
                      },

                      "&.Mui-selected": {
                        backgroundColor: "var(--brand-primary-nav-action)",
                        zIndex: "var(--z-index-content)",
                        cursor: "default",

                        "&:hover": {
                          backgroundColor: "var(--brand-primary-nav-action)",
                        },
                      },

                      "& .MuiPaginationItem-icon": {
                        fontSize: "var(--font-sm)",
                        width: "var(--font-sm)",
                        height: "var(--font-sm)",
                      },
                    }}
                    className="rounded-border-radius-md relative z-z-index-header"
                  />
                );
              }}
            />
          </div>

          <div
            className={`w-auto my-auto ${
              isMobile ? "text-center" : "text-right"
            }`}
          >
            <p className="w-auto text-font-xs text-text-secondary font-semibold font-sans">
              {data?.title?.page_item_count * data?.title?.current_page -
                data?.title?.page_item_count +
                1 || 0}{" "}
              {" - "}
              {Math.min(
                accountType === "internal" && data?.total_count > 0
                  ? totalCount
                  : data?.total_count,
                data?.title?.page_item_count * data?.title?.current_page,
              ) || 0}{" "}
              {" of "}
              {accountType === "internal" && data?.total_count > 0
                ? totalCount?.toLocaleString()
                : data?.total_count?.toLocaleString() || 0}
            </p>
          </div>
        </div>
        <div
          className="Qmd:h-[52px] bg-Blue-7 Qmd:rounded-b-border-radius-md"
          style={{
            display:
              payload?.typepop === "RejectAllTransactionPopup" ||
              typepop === "RejectAllTransactionPopup"
                ? "flex"
                : type === "BeneSchedule"
                  ? "none"
                  : "none",
            width: "100%",
          }}
        >
          <div className="flex flex-row justify-between items-center py-1 px-5 h-full w-width-full">
            <p className="text-sm text-text-primary font-sans font-normal">
              {payload?.typepop === "RejectAllTransactionPopup" &&
              (flowType === "decline_account_require_approval_flow" ||
                flowType === "decline account details") &&
              accountFlow === "Beneficiary" &&
              services?.find((service) => service === "ABeneficiaryTxn") !==
                undefined
                ? 'To reject the account, please reject the transactions listed above by clicking the "Reject all" button. The transactions will get rejected with the provided rejected reason.'
                : typepop === "RejectAllTransactionPopup" &&
                    flowType === "ArchiveAccount" &&
                    accountFlow === "Beneficiary" &&
                    services?.find(
                      (service) => service === "ABeneficiaryTxn",
                    ) !== undefined
                  ? 'To archive the account, please reject the transactions listed above by clicking the "Reject all" button.'
                  : typepop === "RejectAllTransactionPopup" &&
                      accountFlow === "Internal" &&
                      services?.find(
                        (service) => service === "AInternalTxn",
                      ) !== undefined
                    ? 'To reject the account, please reject the transactions listed above by clicking the "Reject all" button. The transactions will get rejected with the provided rejected reason.'
                    : type === "alertAssociated"
                      ? 'To reject the account,please reject the transactions listed above by clicking the "Reject all" button. The transactions will get rejected with the provided rejected reason.'
                      : (payload?.typepop === "RejectAllTransactionPopup" &&
                            type === "scheduleAcc" &&
                            services?.find(
                              (service) => service === "BAScheduledTxn",
                            ) !== undefined) ||
                          (type === "scheduleInternalAcc" &&
                            services?.find(
                              (service) => service === "IAScheduledTxn",
                            ) !== undefined)
                        ? "To reject the account, please reject the schedules listed above by clicking the “Reject all” button. The schedules will get rejected with the provided rejected reason."
                        : "To reject the transactions, please contact the authorised person who has the feature to reject the transactions."}
            </p>
            <div
              className={`w-[85px] h-[32px] rounded-[75px] flex-shrink-0 ${
                services?.find((service) => service === "ABeneficiaryTxn") !==
                  undefined ||
                services?.find((service) => service === "BAScheduledTxn") !==
                  undefined ||
                services?.find((service) => service === "IAScheduledTxn") !==
                  undefined ||
                services?.find((service) => service === "AInternalTxn") !==
                  undefined
                  ? "cursor-pointer bg-negative-act  global-hover-black relative z-z-index-base"
                  : "cursor-default bg-text-secondary"
              }`}
              onClick={() => {
                let servicesReq = [
                  "AInternalTxn",
                  "ABeneficiaryTxn",
                  "BAScheduledTxn",
                  "IAScheduledTxn",
                ];
                if (servicesReq.some((service) => services.includes(service))) {
                  if (payload?.typepop === "RejectAllTransactionPopup") {
                    payload?.handleRejectAllTransaction();
                  } else {
                    handleRejectAllTransaction();
                  }
                }
              }}
            >
              <p className="py-2 px-4 text-xs text-[#F9F9F9] text-center font-sans font-normal leading-[16.34px]">
                Reject all
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PaginationComponent;
